// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinner.ontop {\n    position: fixed;\n    background-color: #aaaaaaaa;\n    z-index: 100;\n}\n\n.spinner {\n    margin: auto;\n    text-align: center;\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n\n.loader {\n    text-align: center;\n    display: table-cell;\n    vertical-align: middle;\n}", ""]);
// Exports
module.exports = exports;
